import BsThreeDots from '@meronex/icons/bs/BsThreeDots';
import icon from './StyledIcon';
export default icon(BsThreeDots);
